import React, { useContext } from "react";
import "../../styles/reviewSection.css";
import manImage from "../../images/man.webp";
import girlImage from "../../images/girl.webp";
import { WebsiteContext } from "../../context/AppContext";
import { IoStar, IoShieldCheckmark } from "react-icons/io5";
import { FaQuoteRight } from "react-icons/fa6";
import { motion } from "framer-motion";

const reviewsData = [
  {
    name: "Manikandan",
    role: "Daily Fluent Fable Learner",
    image: manImage,
    stars: 5,
    comment:
      "This app transformed my approach to mastering English. Combining interactive AI practice with daily vocabulary insights and quizzes gave me the confidence to converse effortlessly in any setting!",
  },
  {
    name: "Keerthiga",
    role: "IELTS & Career Aspirant",
    image: girlImage,
    stars: 5,
    comment:
      "The structured stages from Beginner to Pro make language progress feel genuinely tangible. The daily quote insights with instant synonyms and antonyms have substantially enriched my active vocabulary.",
  },
  {
    name: "Ragav",
    role: "Software Professional",
    image: manImage,
    stars: 5,
    comment:
      "I love how Fluent Fable simulates real-life dialogue. Practicing with the AI tutor eliminated my hesitation during international team meetings and technical presentations. Highly recommended!",
  },
  {
    name: "Anand",
    role: "College Graduate & Job Aspirant",
    image: manImage,
    stars: 5,
    comment:
      "Preparing for campus interviews was intimidating until I practiced with Fluent Fable's AI tutor. Asking phrasing questions and receiving instant corrections gave me the conversational confidence I needed.",
  },
  {
    name: "Gokul",
    role: "Tech Consultant",
    image: manImage,
    stars: 5,
    comment:
      "The daily vocabulary insights with synonyms and antonyms are pure gold. Spending just 5 minutes a day has dramatically expanded my active word bank and sharpened how I articulate ideas.",
  },
  {
    name: "Dhanusya",
    role: "University Student",
    image: girlImage,
    stars: 5,
    comment:
      "The vocabulary and grammar quizzes are both super engaging and practical! Getting immediate feedback with clear explanations helped me correct tricky grammar habits naturally.",
  },
];

const ReviewSection = () => {
  const { color, isMobileView, dark } = useContext(WebsiteContext);

  return (
    <div className={`reviews_section_wrapper ${dark ? "reviews_section_dark" : ""}`}>
      {/* Header */}
      <div className="reviews_header">
        <span className={`reviews_badge ${dark ? "reviews_badge_dark" : "reviews_badge_light"}`}>
          ❤️ Learner Community
        </span>
        <h2 className="reviews_title" style={{ color: color }}>
          Love To Hear <span className="heart_pulse">❤️</span>
        </h2>
        <p className="reviews_subtitle" style={{ color: color }}>
          Real feedback from ambitious learners who transformed their fluency, vocabulary, and speaking confidence with Fluent Fable.
        </p>
      </div>

      {/* Social Proof / Stats Bar */}
      <div className={`reviews_stats_bar ${dark ? "stats_bar_dark" : "stats_bar_light"}`}>
        <div className="stat_item">
          <span className="stat_number">4.8 / 5.0</span>
          <span className="stat_label" style={{ color: color }}>★ Play Store Rating</span>
        </div>
        <div className="stat_divider"></div>
        <div className="stat_item">
          <span className="stat_number">50,000+</span>
          <span className="stat_label" style={{ color: color }}>Active Learners</span>
        </div>
        <div className="stat_divider"></div>
        <div className="stat_item">
          <span className="stat_number">96%</span>
          <span className="stat_label" style={{ color: color }}>Noticeable Fluency Growth</span>
        </div>
      </div>

      {/* Cards Grid */}
      <div className="reviews_grid">
        {reviewsData.map((review, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.35, delay: index * 0.1 }}
            className={`modern_review_card ${dark ? "card_dark" : "card_light"}`}
          >
            {/* Top Stars & Quote Accent */}
            <div className="card_top_row">
              <div className="star_rating">
                {[...Array(review.stars)].map((_, i) => (
                  <IoStar key={i} />
                ))}
              </div>
              <FaQuoteRight className="quote_watermark" />
            </div>

            {/* Review Comment */}
            <p className="card_review_text" style={{ color: color }}>
              "{review.comment}"
            </p>

            {/* Author Footer */}
            <div className="card_author_row">
              <div className="author_avatar_wrap">
                <img src={review.image} alt={review.name} className="author_avatar" />
              </div>
              <div className="author_details">
                <div className="author_name" style={{ color: color }}>
                  {review.name}
                </div>
                <div className="author_role_badge">
                  <IoShieldCheckmark size={13} /> {review.role}
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ReviewSection;
